import React from "react";

interface RenderCellProps {
    title: string;
}

export const TrialBalanceDownloadTitle: React.FC<RenderCellProps> = ({
    title,
}) => (
    <td className="download-table__table__cell download-table__cell--left">
        {title}
    </td>
);
